module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4709.c72ae707.jpg";